import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SummaryType } from '../../enums/enum.type';
import { DateFilter } from '../../models/models';

@Component({
  selector: 'app-select-date',
  templateUrl: './select-date.component.html',
  styleUrls: ['./select-date.component.css']
})
export class SelectDateComponent implements OnInit {

  startDate:number;
  endDate:number;
  startDateValue:string;
  endDateValue:string;
  summaryType:SummaryType = SummaryType.Daily;
  SummaryType = SummaryType;

  selectedFilter ='';
  dateFilterList:DateFilter[]=[];
  yearFilterList:string[]=[];
  selectedYear='';

  @Output() dateFieldEmitter = new EventEmitter<{startDate:number,endDate:number}>();
  constructor() { 
    // getting start date as 6 month ago, and end date as current time.
    let date = new Date();
    // date.setMonth(date.getMonth()-6);
    this.startDate = new Date(date).getTime();
    this.endDate = new Date().getTime();
    this.startDateValue = this.getDateFromTimestamp(this.startDate);
    this.endDateValue  = this.getDateFromTimestamp(this.endDate);
    this.startDate = new Date(date).getTime();
    this.endDate = new Date().getTime();
    this.startDateValue = this.getDateFromTimestamp(this.startDate);
    this.endDateValue  = this.getDateFromTimestamp(this.endDate);
    const currentYear:any = new Date().getFullYear();
    this.selectedYear = currentYear;
    this.setDateFilterList();
  }

  ngOnInit(): void {
    this.onChangeDate();
  }

  onChangeDate =()=>{
    if(this.startDateValue){
      this.startDate = new Date(`${this.startDateValue}T00:00:00`).getTime();
      this.endDate = new Date(`${this.endDateValue}T23:59:59`).getTime();
    }
    this.dateFieldEmitter.emit({startDate:this.startDate,endDate:this.endDate});
  }

  onChangeStartDate(){
    this.onChangeDate();
  }
  onChangeEndDate(){
    this.onChangeDate();
  }


  onChangeFilter=(startDate:string,endDate:string,startMonth:string,endMonth:string,year:string)=>{
    this.startDateValue = `${year}-${startMonth}-${startDate}`;
    this.endDateValue = `${year}-${endMonth}-${endDate}`;
    this.onChangeDate();
  }

  onSelectSummaryType(summaryType:SummaryType){
    this.summaryType = summaryType;
    const currentYear:any = new Date().getFullYear();
    this.selectedYear = currentYear;
    this.setDateFilterList();
  }

  onChangeYear(year:any){
    this.selectedYear = year;
    const startMonth = this.startDateValue.split('-')[1];
    const endMonth = this.endDateValue.split('-')[1];
    const startDate = this.startDateValue.split('-')[2];
    const endDate = this.endDateValue.split('-')[2];
    this.startDateValue = `${year}-${startMonth}-${startDate}`;
    this.endDateValue = `${year}-${endMonth}-${endDate}`;
    this.setLabels();
    this.onChangeDate();
  }

  setLabels(){
    const currentYear:any = this.selectedYear;
    this.dateFilterList = [];
    const currentMainYear:any = new Date().getFullYear();
    this.yearFilterList = [currentMainYear,currentMainYear-1,currentMainYear-2,currentMainYear-3,currentMainYear-4,currentMainYear-5,currentMainYear-6,currentMainYear-7];

    if(this.summaryType == SummaryType.Yearly){
      //  year wise date filter and labels
      this.dateFilterList = [
        {startDate:'01',endDate:'31',startMonth:'01',endMonth:'12',year:currentYear,label:`${currentYear}`},
        {startDate:'01',endDate:'31',startMonth:'01',endMonth:'12',year:currentYear-1,label:`${currentYear-1}`},
        {startDate:'01',endDate:'31',startMonth:'01',endMonth:'12',year:currentYear-2,label:`${currentYear-2}`},
        {startDate:'01',endDate:'31',startMonth:'01',endMonth:'12',year:currentYear-3,label:`${currentYear-3}`},
        {startDate:'01',endDate:'31',startMonth:'01',endMonth:'12',year:currentYear-4,label:`${currentYear-4}`},
        {startDate:'01',endDate:'31',startMonth:'01',endMonth:'12',year:currentYear-5,label:`${currentYear-5}`},
        {startDate:'01',endDate:'31',startMonth:'01',endMonth:'12',year:currentYear-6,label:`${currentYear-6}`},
        {startDate:'01',endDate:'31',startMonth:'01',endMonth:'12',year:currentYear-7,label:`${currentYear-7}`},
      ];
      this.startDateValue=`${currentYear}-01-01`;
      this.endDateValue=`${currentYear}-12-31`;
      this.selectedFilter = currentYear;
    }
    else if(this.summaryType == SummaryType.HalfYearly){
      //  half yearly date filter and labels
      this.dateFilterList = [
        {startDate:'01',endDate:'30',startMonth:'01',endMonth:'06',year:currentYear,label:`H1`},
        {startDate:'01',endDate:'31',startMonth:'07',endMonth:'12',year:currentYear,label:`H2`},
      ];
      this.startDateValue=`${currentYear}-01-01`;
      this.endDateValue=`${currentYear}-06-30`;
      this.selectedFilter = `H1`;
    }
    else if(this.summaryType == SummaryType.Quarterly){
      //  Quaterly date filter and labels
      this.dateFilterList = [
        {startDate:'01',endDate:'31',startMonth:'01',endMonth:'03',year:currentYear,label:`Q1`},
        {startDate:'01',endDate:'30',startMonth:'04',endMonth:'06',year:currentYear,label:`Q2`},
        {startDate:'01',endDate:'30',startMonth:'07',endMonth:'09',year:currentYear,label:`Q3`},
        {startDate:'01',endDate:'31',startMonth:'10',endMonth:'12',year:currentYear,label:`Q4`},
      ]
      this.startDateValue=`${currentYear}-01-01`;
      this.endDateValue=`${currentYear}-03-31`;
      this.selectedFilter = `Q1`;
    }
    else if(this.summaryType == SummaryType.Monthly){
      //  Monthly date filter and labels
      this.dateFilterList = [
        {startDate:'01',endDate:'31',startMonth:'01',endMonth:'01',year:currentYear,label:'Jan'},
        {startDate:'01',endDate:'28',startMonth:'02',endMonth:'02',year:currentYear,label:'Feb'},
        {startDate:'01',endDate:'31',startMonth:'03',endMonth:'03',year:currentYear,label:'Mar'},
        {startDate:'01',endDate:'30',startMonth:'04',endMonth:'04',year:currentYear,label:'Apr'},
        {startDate:'01',endDate:'31',startMonth:'05',endMonth:'05',year:currentYear,label:'May'},
        {startDate:'01',endDate:'30',startMonth:'06',endMonth:'06',year:currentYear,label:'Jun'},
        {startDate:'01',endDate:'31',startMonth:'07',endMonth:'07',year:currentYear,label:'Jul'},
        {startDate:'01',endDate:'31',startMonth:'08',endMonth:'08',year:currentYear,label:'Aug'},
        {startDate:'01',endDate:'30',startMonth:'09',endMonth:'09',year:currentYear,label:'Sep'},
        {startDate:'01',endDate:'31',startMonth:'10',endMonth:'10',year:currentYear,label:'Oct'},
        {startDate:'01',endDate:'30',startMonth:'11',endMonth:'11',year:currentYear,label:'Nov'},
        {startDate:'01',endDate:'31',startMonth:'12',endMonth:'12',year:currentYear,label:'Dec'},
      ]
      this.startDateValue=`${currentYear}-01-01`;
      this.endDateValue=`${currentYear}-01-31`;
      this.selectedFilter = `Jan`;
    }
  }

  setDateFilterList(){
    this.setLabels();
    this.onChangeDate();
  }

  getDateFromTimestamp(timestamp:number){
    let date = new Date(timestamp)
    const lpad2 = (num:any) => String(num).padStart(2, "0")
    return (
      date.getFullYear() + "-" + lpad2(date.getMonth() + 1) + "-" + lpad2(date.getDate())
    )
  }

}
